import { UntypedFormBuilder } from "@angular/forms";

export interface HelpText {
    code: string;
    description: string;
}

export class HelpTextFormBuilder {
   
    static getForm(fb: UntypedFormBuilder, helpText: HelpText) {

        return fb.group(
            {
                code: [helpText.code],
                description: [helpText.description],
            }
        );
    }

    static initHelpText(code:string): HelpText {

        return {
            code: code,
            description: '',

        };
    }
}